import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import SnackStore from '../../../stores/SnackStore';
import PolicyStore from '../../../stores/Policy/PolicyStore';
import ConcurrencyPopUp from '../../ConcurrencyPopUp/ConcurrencyPopUp';
import { FTBody, Page, Card, FTHeading } from '../../Fuse';
import StackL from '../../Spacers/Spacers';
import { TStrong } from '../../Text/Text';
import PolicyTable from '../PolicyTable';
import CustomCategoriesModal from './CustomCategoriesModal';
import ConsoleStore from '../../../stores/ConsoleStore';
import { ROLE_READ_ONLY } from '../../../stores/Administrators/AdministratorModalStore';

class CustomCategories extends Component {
    static propTypes = {
        console: ConsoleStore.PropType,
        snack: SnackStore.PropType.isRequired,
        policy: PolicyStore.PropType.isRequired,
    };

    filterDefaultColumns = ({ index }) => ({
        [PolicyTable.COL_INDEXES.DESCRIPTION]: true,
        [PolicyTable.COL_INDEXES.NAME]: true,
        [PolicyTable.COL_INDEXES.MENU]: true
    })[index];

    searchFilter = (term) => (arr) => {
        term = term ? term.toLowerCase() : '';
        if (!term) {
            return arr;
        }
        return arr.filter(({ name, categoryIpAndUrlPatterns }) => (
            (name ? name.toLowerCase() : '').indexOf(term) > -1) ||
            (categoryIpAndUrlPatterns.findIndex((entry) => (entry ? entry.toLowerCase() : '').indexOf(term) > -1) > -1)
        );
    }

    renderTable = () =>
        <PolicyTable
            defaultItemSuffix={'All Pages'}
            changePriorityAction={false}
            readOnly={this.props.console.authority === ROLE_READ_ONLY.value}
            store={this.props.policy.customCategories.policyTable}
            snack={this.props.snack}
            searchPlaceholder="Search by Name or Domain"
            noItemsText="adding a custom category"
            itemName="Category"
            itemNameFull="Custom Category"
            loadFailedMessage="Failed to load categories."
            columnsConfig={{ colFilter: this.filterDefaultColumns }}
            searchFilter={this.searchFilter}
        />;

    renderAboutSection = () => {
        return <Card title="What are Custom Categories?">
            <FTBody>
                Custom Categories are named lists of IP Addresses and URLs provided by the customer.
            </FTBody>
            <StackL />
            <FTHeading>When are Custom Categories Applied?</FTHeading>
            <StackL />
            <FTBody>
                When a user requests a URL, the system detects all Standard and Custom Categories that apply to the URL.
                The detected categories are then used by the system when determining if there is a matching
                Exclusion Rule, Redirect Rule, or Content Rule that need to be enforced.
            </FTBody>
            <StackL />
            <FTHeading>How to Use Custom Categories</FTHeading>
            <StackL />
            <FTBody><TStrong> Step 1. Add new Custom Categories for specified URLs </TStrong></FTBody>
            <StackL />
            <FTBody>
                Name the Custom Category and enter/paste your specific group of URL Patterns and IP
                Addresses into its bulk text editor.
            </FTBody>
            <StackL />
            <FTBody><TStrong>
                Step 2. Select the Custom Category when defining a Rule’s Match Criteria
            </TStrong></FTBody>
            <StackL />
            <FTBody>This is how you create Rules for specific sites.</FTBody>
            <StackL />

            <FTHeading>Common Use Case</FTHeading>
            <StackL />
            <FTBody>
                To prevent known safe sites from being Isolated,
                create a &quot;Never Isolate URLs&quot; Custom Category with a list of URLs for known safe sites.
                You can then create an Exclusion Rule that matches with the new Custom Category.
            </FTBody>
            <StackL />
        </Card>;
    }

    render() {
        return <Fragment>
            <Page title="Policies - Custom Categories">
                {this.renderTable()}
                {this.renderAboutSection()}
            </Page>

            <CustomCategoriesModal />

            <ConcurrencyPopUp
                store={this.props.policy.customCategories.policyTable.concurrencyPopUpStore}
                revisionType={'CustomerCategory'}
            />
        </Fragment>;
    }
}

export default inject('console', 'snack', 'policy')(observer(CustomCategories));
